/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaGiftCardContainerViewProps } from './citta-gift-card-container';

export default (props: ICittaGiftCardContainerViewProps) => {
    const { GiftCardWrapper, giftCardContent, giftCardForm, SlotWrapper } = props;
    return (
        <Module {...GiftCardWrapper} >
            <Node {...SlotWrapper}>
                {...giftCardContent}
            </Node>
            <Node {...SlotWrapper}>
            {...giftCardForm}
            </Node>
        </Module>
    );
};
